import { render, staticRenderFns } from "./commentsPannel.vue?vue&type=template&id=502269fc"
import script from "./commentsPannel.vue?vue&type=script&lang=js"
export * from "./commentsPannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports